import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { FormRowV3 } from './FormRowV3';

var FormBuilderV3 = function FormBuilderV3(props) {
  return /*#__PURE__*/React.createElement(React.Fragment, null, props.rows.map(function (row, index) {
    return /*#__PURE__*/React.createElement(FormRowV3, _extends({
      key: index,
      row: row
    }, props));
  }));
};

export { FormBuilderV3 };